import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { fetchDebtLoadCalculateFailed } from "../../../../redux/actions/debtLoadAction";
import DebtResultsLoader from "./DebtResultLoader";
import { Message } from "../../../utilites";
import "../debtLoadCalculation.scss";

const DebtResults = ({ debtLoadCalculation, debtLoadCalculationLoading, calculateError }) => {
  const dispatch = useDispatch();
  const {
    minAvailablePayment,
    debtOverloadRate,
    debtOverloadLimit,
    isDebtOverloaded,
    totalIssuedAmountClientDeals,
    totalChargeAmountClientDeals,
    isFreeMoneyLessThenMinBudget,
    minMonthDuration,
  } = { ...debtLoadCalculation };

  const isDebtOverloadRateInfinity = debtOverloadRate === 1000 && minAvailablePayment === 0 && isDebtOverloaded && !isFreeMoneyLessThenMinBudget

  useEffect(() => {
    return () => dispatch(fetchDebtLoadCalculateFailed(null));
  }, []);

  return (
    <div className="entry-wrapper">
      {debtLoadCalculationLoading ? <DebtResultsLoader/> :
      <div className="d-flex columns-2">
        <div className="d-flex flex-column flex-space-between flex-2">
          <div className="d-flex flex-direction-row flex-space-between align-center">
            <h3>Результаты ПДН</h3>
            {isFreeMoneyLessThenMinBudget && (
              <h4 className="font-color-success">Превышен размер БПМ</h4>
            )}
          </div>
          {calculateError ? (
            <Message type="notification" text={calculateError} />
          ) : (
            <>
              <div className="d-flex flex-space-between flex-1 align-center">
                <label className="form-element-label">Допустимый платеж:</label>
                <p className="font-size-larger nowrap m-l-spacer">
                  {minAvailablePayment} BYN/мес
                </p>
              </div>
              <div className="d-flex flex-space-between align-center">
                <label className="form-element-label">Превышение:</label>
                <p className="font-size-larger nowrap m-l-spacer">
                  {debtOverloadRate.toFixed(2)}% {isDebtOverloadRateInfinity && <span>&#8734;</span>} (лимит {debtOverloadLimit}%)
                </p>
              </div>
              <div className="d-flex flex-space-between">
                <label className="form-element-label">Минимальный срок займа:</label>
                <p className="font-size-larger nowrap m-l-spacer">
                  {minAvailablePayment === 0 ? 0 : minMonthDuration} мес.
                </p>
              </div>
              {totalIssuedAmountClientDeals && <>
                <h4>Текущие обязательства клиента</h4>
                <div className="d-flex flex-space-between">
                  <label className="form-element-label">
                    Сумма предоставленных микрозаймов:
                  </label>
                  <p className="font-size-larger nowrap m-l-spacer">
                    {totalIssuedAmountClientDeals} BYN
                  </p>
                </div><div className="d-flex flex-space-between">
                  <label className="form-element-label">Сумма на выкуп:</label>
                  <p className="font-size-larger nowrap m-l-spacer">
                    {totalChargeAmountClientDeals} BYN
                  </p>
                </div></>}
            </>
          )}
        </div>
      </div>}
    </div>
  );
};

export default DebtResults;
